import { useState } from 'react';
import { useLocation, BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import LoginPage        from './pages/LoginPage';
import DashboardPage    from './pages/DashboardPage';
import UsersPage        from './pages/UsersPage';
import TransactionsPage from './pages/TransactionsPage';
import SettingsPage     from './pages/SettingsPage';
import VaultPage        from './pages/VaultPage';
import AdminsPage       from './pages/AdminsPage';
import TestPage         from './pages/TestPage';
import KeywordsPage     from './pages/KeywordsPage';

const NAV = [
  { id:'dashboard',    label:'Dashboard',    path:'/dashboard',    icon: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
      <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
    </svg>
  )},
  { id:'users',        label:'Users',        path:'/users',        icon: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
    </svg>
  )},
  { id:'transactions', label:'Transactions',  path:'/transactions', icon: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
    </svg>
  )},
  { id:'keywords',     label:'Moderation',   path:'/keywords',     icon: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  )},
  { id:'settings',     label:'Settings',     path:'/settings',     icon: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
    </svg>
  )},
  { id:'admins',       label:'Admins',       path:'/admins',       icon: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
    </svg>
  )},
  { id:'test',         label:'System Test',  path:'/test',         icon: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="9 11 12 14 22 4"/>
      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
    </svg>
  )},
  { id:'vault',        label:'Vault',        path:'/vault',        icon: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/>
    </svg>
  )},
];

function Sidebar({ page, onNavigate, onLogout }) {
  return (
    <aside style={s.sidebar}>
      <div style={s.brand}>
        <div style={s.brandLogo}>
          <img src="/tbold-logo-admin-05.svg" alt="Thunderbolt" style={{width:32, height:32, objectFit:'contain'}}/>
        </div>
        <div>
          <div style={s.brandName}>Thunderbolt</div>
          <div style={s.brandSub}>Admin</div>
        </div>
      </div>
      <nav style={s.nav}>
        {NAV.map(n => {
          const active = page === n.id;
          return (
            <button key={n.id}
              style={{...s.navBtn, ...(active ? s.navBtnActive : {})}}
              onClick={() => onNavigate(n.id, n.path)}>
              <span style={{...s.navIcon, color: active ? '#007AFF' : '#AEAEB2'}}>
                <n.icon/>
              </span>
              <span style={{color: active ? '#1D1D1F' : '#6E6E73'}}>{n.label}</span>
            </button>
          );
        })}
      </nav>
      <button style={s.logoutBtn} onClick={onLogout}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
        </svg>
        Log out
      </button>
    </aside>
  );
}

function AuthedApp() {
  const navigate = useNavigate();
  const location = useLocation();
  const page     = location.pathname.replace('/', '') || 'dashboard';

  function logout() {
    localStorage.removeItem('admin_token');
    window.location.href = '/';
  }

  return (
    <div style={s.app}>
      <Sidebar page={page} onNavigate={(id, path) => navigate(path)} onLogout={logout}/>
      <main style={s.main}>
        <Routes>
          <Route path="/"             element={<Navigate to="/dashboard"/>}/>
          <Route path="/dashboard"    element={<DashboardPage/>}/>
          <Route path="/users"        element={<UsersPage/>}/>
          <Route path="/transactions" element={<TransactionsPage/>}/>
          <Route path="/keywords"     element={<KeywordsPage/>}/>
          <Route path="/settings"     element={<SettingsPage/>}/>
          <Route path="/vault"        element={<VaultPage/>}/>
          <Route path="/admins"       element={<AdminsPage/>}/>
          <Route path="/test"         element={<TestPage/>}/>
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('admin_token'));

  if (!token) return (
    <LoginPage onLogin={t => {
      localStorage.setItem('admin_token', t);
      setToken(t);
    }}/>
  );

  return (
    <BrowserRouter>
      <AuthedApp/>
    </BrowserRouter>
  );
}

const s = {
  app:          { display:'flex', minHeight:'100vh', background:'#F5F5F7' },
  sidebar:      { width:220, background:'#fff', borderRight:'1px solid rgba(0,0,0,0.06)', display:'flex', flexDirection:'column', padding:'24px 12px', position:'fixed', height:'100vh', boxShadow:'2px 0 20px rgba(0,0,0,0.04)' },
  brand:        { display:'flex', alignItems:'center', gap:10, padding:'0 8px', marginBottom:32 },
  brandLogo:    { width:36, height:36, borderRadius:10, background:'#007AFF', display:'flex', alignItems:'center', justifyContent:'center' },
  brandName:    { fontSize:15, fontWeight:600, color:'#1D1D1F' },
  brandSub:     { fontSize:11, color:'#AEAEB2' },
  nav:          { flex:1, display:'flex', flexDirection:'column', gap:2 },
  navBtn:       { display:'flex', alignItems:'center', gap:10, padding:'10px 12px', borderRadius:10, border:'none', background:'transparent', fontSize:14, fontWeight:500, cursor:'pointer', textAlign:'left', width:'100%' },
  navBtnActive: { background:'#EBF4FF' },
  navIcon:      { display:'flex', alignItems:'center', flexShrink:0 },
  logoutBtn:    { display:'flex', alignItems:'center', gap:8, padding:'10px 12px', background:'none', border:'none', color:'#AEAEB2', fontSize:13, cursor:'pointer', borderRadius:10 },
  main:         { marginLeft:220, flex:1, padding:32, minHeight:'100vh' }
};
